import { render, staticRenderFns } from "./InstantTournamentHistoryLadderModal.vue?vue&type=template&id=5a047d30&"
import script from "./InstantTournamentHistoryLadderModal.vue?vue&type=script&lang=js&"
export * from "./InstantTournamentHistoryLadderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports